import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import IMask from 'imask';

const helpers = window.BASE_HELPERS || {};
const { Copy, Forms, MessageBox, Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="formulario_contato"]');
const RECAPTCHA_ACTION = 'fale_conosco';

class FormularioContato {
    constructor() {
        this.components = MODULE;
        this.init();
        this.scrollToForm();
        this.rdStation();
    }

    init() {
        this.components.forEach(component => {
            Copy.initCopy();

            new Bouncer('.formulario-contato', {
                disableSubmit: true,
                messageAfterField: false,
                messages: {
                    missingValue: {
                        checkbox: '',
                        radio: '',
                        select: '',
                        'select-multiple': '',
                        default: 'Campo de preenchimento obrigatório',
                    },
                    patternMismatch: {
                        email: 'Por favor, insira um e-mail válido',
                        telefone: 'Por favor, insira um telefone válido',
                        default: 'Formato inválido',
                    },
                },
                emitEvents: true,
            });

            const form = component.querySelector('form');

            if (form) {
                const buttonSubmit = form.querySelector('[type="submit"]');

                if (buttonSubmit && Forms?.enableSubmitAfterRecaptchaValid) {
                    Forms.enableSubmitAfterRecaptchaValid(RECAPTCHA_ACTION, buttonSubmit);
                }

                const tel = form.querySelector('[name="telefone"]');

                if (tel) {
                    IMask(
                        tel,
                        {
                            mask: '(00) 00000-0000'
                        }
                    )
                }

                const cpf = form.querySelector('[name="cpf"]');

                if (cpf) {

                    IMask(
                        cpf,
                        {
                            mask: '000.000.000-00'
                        }
                    )
                }

                const cnpj = form.querySelector('[name="cnpj"]');

                if (cnpj) {

                    IMask(
                        cnpj,
                        {
                            mask: '00.000.000/0000-00'
                        }
                    )
                }

                form.addEventListener('bouncerFormInvalid', () => {
                    if (navigator.vibrate) {
                        navigator.vibrate([100, 50, 100]);
                    }
                });

                form.addEventListener('bouncerFormValid', async (event) => {
                    event.preventDefault();

                    const buttonSubmit = event.target.querySelector('[type="submit"]');
                    const recaptchaInput = form.querySelector("input[name='recaptcha_token']");
                    const recaptchaActionInput = form.querySelector("input[name='recaptcha_action']");

                    if (recaptchaActionInput) {
                        recaptchaActionInput.value = RECAPTCHA_ACTION;
                    }

                    buttonSubmit.setAttribute('disabled', 'disabled');
                    buttonSubmit.innerText = "Enviando...";

                    const sendForm = async () => {
                        const formData = new FormData(event.target);

                        const formObject = {};
                        formData.forEach((value, key) => {
                            formObject[key] = value;
                        });

                        const response = await axios.post(
                            `${AppSettings.baseApiUrl}basedigital/v1/fale-conosco/`,
                            formObject,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                }
                            }
                        );

                        form.reset();
                        buttonSubmit.removeAttribute('disabled');
                        buttonSubmit.innerText = "Enviar mensagem";

                        if (response.status === 200) {
                            MessageBox.showOnce({
                                target: form,
                                position: 'bottom',
                                type: 'success',
                                message: i18n.message.formNewsletterSuccess,
                                classes: 'text-sm text-verde font-normal pt-[10px]',
                                timeout: 8000,
                            });
                        } else {
                        }
                    };

                    if (typeof window.reloadCaptcha === 'function') {
                        window.reloadCaptcha(
                            RECAPTCHA_ACTION,
                            'recaptcha_token',
                            async (token) => {
                                if (recaptchaInput) {
                                    recaptchaInput.value = token;
                                }

                                try {
                                    await sendForm();
                                } catch (error) {
                                    buttonSubmit.removeAttribute('disabled');

                                    const responseData = error?.response?.data;
                                    console.log('Erro reCAPTCHA:', error.response.data);

                                    if (responseData?.code && String(responseData.code).startsWith('recaptcha_')) {
                                        console.warn('Erro reCAPTCHA:', responseData);
                                    } else {
                                    }
                                }
                            }
                        );
                    } else {
                        console.warn('reloadCaptcha não está disponível. Enviando sem reCAPTCHA.');
                        try {
                            await sendForm();
                        } catch (error) {
                            buttonSubmit.removeAttribute('disabled');
                            errorBox?.classList.add('active');
                            console.error(error);
                        }
                    }
                });
            }
        });
    }

    scrollToForm() {
        document.addEventListener('click', function (e) {
            const link = e.target.closest('a[href^="#"]');

            if (!link) {
                return;
            }

            const hash = link.getAttribute('href');

            if (!hash || hash === '#') {
                return;
            }

            const target = document.getElementById(hash.substring(1));

            if (!target) {
                return;
            }

            e.preventDefault();

            const header_height = Mobile.isMobile() ? 160 : 220;

            const scrollPosition = target.getBoundingClientRect().top + window.scrollY - header_height;

            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        });
    }

    rdStation() {
        this.components.forEach(component => {
            component.addEventListener('submit', function (event) {
                const form = event.target;

                if (
                    form.tagName === 'FORM' &&
                    form.closest('.form-external .rd-form')
                ) {
                    setTimeout(() => {
                        form.reset();
                    }, 100);
                }
            });
        });
    }
}

(() => {
    if (MODULE) {
        new FormularioContato();
    }
})();

export default FormularioContato;
